import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';

import { GA4AnalyticsCategoryEffects } from '../GA4/store/features-analytics/category/analytics-category.effects';

@NgModule({
    providers: [
        provideEffects(GA4AnalyticsCategoryEffects),
    ],
})
export class AnalyticsCategoryModule { }
